import { isAfter, now, subtractTime } from '@/utils/date';
import hasOwnKey from '@/utils/hasOwnKey';

const UNKNOWN_STATE = 'unknown';
const STALLED_STATE_THRESHOLD = 3 * 60; // 3 minutes

const states: Record<string, string> = {
    created: 'created',
    started: 'started',
    error: 'error',
    stopped: 'stopped',
    finished: 'finished',
    stalled: 'stalled',
    warning: 'warning',
};

interface BatchServiceStatusProps {
    status: string;
    updatedAt?: Date;
}

function batchServiceStatus({ status, updatedAt }: BatchServiceStatusProps) {
    if (!hasOwnKey(states, status)) return { status: UNKNOWN_STATE };

    if (
        updatedAt &&
        (status === 'created' || status === 'started') &&
        isAfter(subtractTime(now(), STALLED_STATE_THRESHOLD, 'second'), updatedAt)
    ) {
        return { status: states.stalled };
    }

    return { status: states?.[status] };
}

export default batchServiceStatus;
